import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

export const ThemeContext = createContext();

export const ThemeConsumer = ThemeContext.Consumer;

const initialState = {
  isReady: false,
  color: 'green',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ACCENT_COLOR':
      return {
        ...state,
        isReady: true,
        color: action.payload
      };
    case 'SET_DEFAULT_ACCENT_COLOR':
      return {
        ...state,
        isReady: true,
        color: 'green'
      };
    default:
      throw new Error();
  }
};

export const ThemeProvider = props => {
  const [themeState, themeDispatch] = useReducer(reducer, initialState);

  return (
    <ThemeContext.Provider value={[themeState, themeDispatch]}>
      {props.children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};
